import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';
import classes from './DropdownMenuMobile.module.scss';
const DropdownMenuMobile = ({
  title,
  items
}) => {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const toggleMenu = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleItemClick = link => {
    window.open(link, '_self', 'noopener,noreferrer');
    setOpen(false);
  };
  return <>
			<ListItemButton onClick={toggleMenu} className={classes['list']} aria-expanded={open} aria-controls={`${title.toLowerCase()}-menu`} aria-label={`${title} menu - ${open ? 'collapse' : 'expand'}`} data-sentry-element="ListItemButton" data-sentry-source-file="DropdownMenuMobile.tsx">
				<ListItemText primary={title} primaryTypographyProps={{
        color: 'primary',
        fontWeight: 'bold'
      }} data-sentry-element="ListItemText" data-sentry-source-file="DropdownMenuMobile.tsx" />
				{open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
			</ListItemButton>
			<Collapse in={open} timeout="auto" unmountOnExit id={`${title.toLowerCase()}-menu`} data-sentry-element="Collapse" data-sentry-source-file="DropdownMenuMobile.tsx">
				<List component="div" disablePadding role="menu" aria-label={`${title} submenu`} data-sentry-element="List" data-sentry-source-file="DropdownMenuMobile.tsx">
					{items.map((item, index) => <ListItemButton key={index} onClick={() => handleItemClick(item.link)} sx={{
          pl: 4
        }} role="menuitem" aria-label={`Go to ${item.text} page`}>
							<ListItemText primary={item.text} />
						</ListItemButton>)}
				</List>
			</Collapse>
		</>;
};
export default DropdownMenuMobile;